import { type NexusApiCategory } from "../workflow.types";
import { type NexusApiActionDef } from "./action-def.types";
import { agentActions } from "./agent.actions";
import { collectionActions } from "./collection.actions";
import { deploymentActions } from "./deployment.actions";
import { documentActions } from "./document.actions";
import { documentTemplateActions } from "./document-template.actions";
import { emulatorActions } from "./emulator.actions";
import { executionActions } from "./execution.actions";
import { inboxActions } from "./inbox.actions";
import { memoryActions } from "./memory.actions";
import { taskActions } from "./task.actions";
import { workflowActions } from "./workflow.actions";
import { workspaceActions } from "./workspace.actions";

export const NEXUS_API_ACTIONS: Record<NexusApiCategory, NexusApiActionDef[]> = {
  agents: agentActions,
  tasks: taskActions,
  collections: collectionActions,
  documents: documentActions,
  documentTemplates: documentTemplateActions,
  deployments: deploymentActions,
  emulator: emulatorActions,
  inbox: inboxActions,
  workflows: workflowActions,
  executions: executionActions,
  workspace: workspaceActions,
  memory: memoryActions
};

export function getActionDef(action: string): NexusApiActionDef | undefined {
  for (const actions of Object.values(NEXUS_API_ACTIONS)) {
    const found = actions.find((a) => a.action === action);
    if (found) return found;
  }
  return undefined;
}

export function getActionsForCategory(category: NexusApiCategory): NexusApiActionDef[] {
  return NEXUS_API_ACTIONS[category] ?? [];
}
